import BillingsOrderForwardBillingsListRequest, {
  BillingsOrderForwardBillingsListRequestOrder,
} from "../../../../api/raily/billings/order-forward-billings/list/billings-order-forward-billings-list.request";
import BillingsOrderForwardBillingsListParams, {
  BillingsOrderForwardBillingsListParamsOrder,
} from "./billings-order-forward-billings-list-params";

const createOrder = (
  order: BillingsOrderForwardBillingsListParamsOrder | undefined,
): BillingsOrderForwardBillingsListRequestOrder | undefined => {
  switch (order) {
    case BillingsOrderForwardBillingsListParamsOrder.BILLING_MODEL_ASC:
      return BillingsOrderForwardBillingsListRequestOrder.BILLING_MODEL_ASC;
    case BillingsOrderForwardBillingsListParamsOrder.BILLING_MODEL_DESC:
      return BillingsOrderForwardBillingsListRequestOrder.BILLING_MODEL_DESC;
    case BillingsOrderForwardBillingsListParamsOrder.CONSUMER_ASC:
      return BillingsOrderForwardBillingsListRequestOrder.CONSUMER_ASC;
    case BillingsOrderForwardBillingsListParamsOrder.CONSUMER_DESC:
      return BillingsOrderForwardBillingsListRequestOrder.CONSUMER_DESC;
    case BillingsOrderForwardBillingsListParamsOrder.DATE_AT_ASC:
      return BillingsOrderForwardBillingsListRequestOrder.DATE_AT_ASC;
    case BillingsOrderForwardBillingsListParamsOrder.DATE_AT_DESC:
      return BillingsOrderForwardBillingsListRequestOrder.DATE_AT_DESC;
    case BillingsOrderForwardBillingsListParamsOrder.DISTANCE_AMOUNT_ASC:
      return BillingsOrderForwardBillingsListRequestOrder.DISTANCE_AMOUNT_ASC;
    case BillingsOrderForwardBillingsListParamsOrder.DISTANCE_AMOUNT_DESC:
      return BillingsOrderForwardBillingsListRequestOrder.DISTANCE_AMOUNT_DESC;
    case BillingsOrderForwardBillingsListParamsOrder.DISTANCE_ASC:
      return BillingsOrderForwardBillingsListRequestOrder.DISTANCE_ASC;
    case BillingsOrderForwardBillingsListParamsOrder.DISTANCE_DESC:
      return BillingsOrderForwardBillingsListRequestOrder.DISTANCE_DESC;
    case BillingsOrderForwardBillingsListParamsOrder.DISTANCE_RATE_ASC:
      return BillingsOrderForwardBillingsListRequestOrder.DISTANCE_RATE_ASC;
    case BillingsOrderForwardBillingsListParamsOrder.DISTANCE_RATE_DESC:
      return BillingsOrderForwardBillingsListRequestOrder.DISTANCE_RATE_DESC;
    case BillingsOrderForwardBillingsListParamsOrder.HALTING_AMOUNT_ASC:
      return BillingsOrderForwardBillingsListRequestOrder.HALTING_AMOUNT_ASC;
    case BillingsOrderForwardBillingsListParamsOrder.HALTING_AMOUNT_DESC:
      return BillingsOrderForwardBillingsListRequestOrder.HALTING_AMOUNT_DESC;
    case BillingsOrderForwardBillingsListParamsOrder.HIGHWAY_CHARGE_ASC:
      return BillingsOrderForwardBillingsListRequestOrder.HIGHWAY_CHARGE_ASC;
    case BillingsOrderForwardBillingsListParamsOrder.HIGHWAY_CHARGE_DESC:
      return BillingsOrderForwardBillingsListRequestOrder.HIGHWAY_CHARGE_DESC;
    case BillingsOrderForwardBillingsListParamsOrder.HUMAN_ID_ASC:
      return BillingsOrderForwardBillingsListRequestOrder.HUMAN_ID_ASC;
    case BillingsOrderForwardBillingsListParamsOrder.HUMAN_ID_DESC:
      return BillingsOrderForwardBillingsListRequestOrder.HUMAN_ID_DESC;
    case BillingsOrderForwardBillingsListParamsOrder.PRODUCER_ASC:
      return BillingsOrderForwardBillingsListRequestOrder.PRODUCER_ASC;
    case BillingsOrderForwardBillingsListParamsOrder.PRODUCER_DESC:
      return BillingsOrderForwardBillingsListRequestOrder.PRODUCER_DESC;
    case BillingsOrderForwardBillingsListParamsOrder.TOTAL_AMOUNT_ASC:
      return BillingsOrderForwardBillingsListRequestOrder.TOTAL_AMOUNT_ASC;
    case BillingsOrderForwardBillingsListParamsOrder.TOTAL_AMOUNT_DESC:
      return BillingsOrderForwardBillingsListRequestOrder.TOTAL_AMOUNT_DESC;
    default:
      return undefined;
  }
};

const create = (
  params: BillingsOrderForwardBillingsListParams,
): BillingsOrderForwardBillingsListRequest => {
  return {
    limit: params.limit,
    offset: params.offset,
    consumer: params.consumer,
    humanId: params.humanId,
    order: createOrder(params.order),
    producer: params.producer,
    startTimeSince: params.startTimeSince,
    startTimeTo: params.startTimeTo,
    status: params.status,
    taxiCorporationId: params.taxiCorporationId,
  };
};

const billingsOrderForwardBillingsListParamsFactory = {
  create,
};

export default billingsOrderForwardBillingsListParamsFactory;
